import React, { useState, useEffect } from 'react';
import { getAnalyses, downloadExcel, deleteAnalysis } from '../../services/analyses';
import './ExcelManager.css';

const ExcelManager = () => {
  const [excels, setExcels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadExcels();
  }, []);

  const loadExcels = async () => {
    try {
      const data = await getAnalyses();
      const completedAnalyses = (data.analyses || []).filter(
        (a) => a.status === 'completed'
      );
      setExcels(
        completedAnalyses.map((a) => ({
          ...a,
          active: true,
        }))
      );
    } catch (error) {
      console.error('Error loading excels:', error);
    } finally {
      setLoading(false);
    }
  };

  const toggleActive = (hash) => {
    setExcels(
      excels.map((excel) =>
        excel.hash === hash ? { ...excel, active: !excel.active } : excel
      )
    );
  };

  const handleDownload = async (excel) => {
    try {
      const fecha = new Date(excel.created).toISOString().slice(0,10).replace(/-/g, '');
      const baseName = excel.filename.replace(/\.[^/.]+$/, '');
      const filename = `analisis_${baseName}_${fecha}.xlsx`;
      await downloadExcel(excel.hash, filename);
    } catch (error) {
      console.error('Error downloading excel:', error);
      alert('Error al descargar el Excel');
    }
  };

  const handleDelete = async (hash) => {
    if (window.confirm('¿Está seguro de eliminar este excel?')) {
      try {
        await deleteAnalysis(hash);
        setExcels(excels.filter((excel) => excel.hash !== hash));
      } catch (error) {
        console.error('Error deleting analysis:', error);
        alert('Error al eliminar el análisis');
      }
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES');
  };

  const getExcelName = (analysis) => {
    const fecha = new Date(analysis.created).toISOString().slice(0,10).replace(/-/g, '');
    const baseName = analysis.filename.replace(/\.[^/.]+$/, '');
    return `analisis_${baseName}_${fecha}`;
  };

  if (loading) {
    return <div className="loading">Cargando excels...</div>;
  }

  return (
    <div className="excel-container">
      <h1 className="excel-title">Excels generados</h1>

      <table className="excel-table">
        <thead>
          <tr>
            <th>Activo</th>
            <th>Excels generados ↕</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {excels.map((excel) => (
            <tr key={excel.hash}>
              <td>
                <input
                  type="checkbox"
                  checked={excel.active}
                  onChange={() => toggleActive(excel.hash)}
                  className="checkbox-active"
                />
              </td>
              <td>{getExcelName(excel)}</td>
              <td className="excel-actions">
                <button
                  className="btn-download-icon"
                  onClick={() => handleDownload(excel)}
                  title="Descargar"
                >
                  ⬇
                </button>
                <button
                  className="btn-delete-icon"
                  onClick={() => handleDelete(excel.hash)}
                  title="Eliminar"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2M10 11v6M14 11v6"/>
                  </svg>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {excels.length === 0 && (
        <div className="empty-state">
          No hay excels generados todavía
        </div>
      )}
    </div>
  );
};

export default ExcelManager;